import type { UnifiedTableDataType } from '@/components/ui/unifiedTable/UnifiedTable';

export type CandidateProgramConfig = {
  component: string;
  title: string;
  subtitle: string;
  dataTypeOverrides?: Record<string, UnifiedTableDataType>;
  tableHeight?: string;
  newlineFields?: string[];
  newlineFieldLabelPatterns?: RegExp[];
  leadReferralExportSites?: Array<{ label: string; site: string | null }>;
  inrepReportProgramOptions?: string[];
  covidTestingProgramOptions?: string[];
  covidVaccineProgramOptions?: string[];
  influenzaProgramOptions?: string[];
  influenzaNotReceivedOptions?: string[];
  progressReportHubOptions?: Array<{ label: string; value: string }>;
  progressReportAppearanceOptions?: Array<{ label: string; value: string }>;
  mistDispositionOptions?: string[];
  mistConditionalReleaseOutcomeOptions?: string[];
  mistDate317SecondOptions?: string[];
  mistOutcomeOptions?: string[];
  mistReportFields?: string[];
  mistReportColumnWidths?: number[];
};

type CandidateProgramConfigSource = Omit<CandidateProgramConfig, 'newlineFieldLabelPatterns'> & {
  newlineFieldLabelPatterns?: string[];
};

export const toProgramConfig = (source: CandidateProgramConfigSource): CandidateProgramConfig => {
  const patterns = Array.isArray(source.newlineFieldLabelPatterns)
    ? source.newlineFieldLabelPatterns.map((pattern) => new RegExp(pattern, 'i'))
    : undefined;

  return {
    ...source,
    newlineFieldLabelPatterns: patterns,
  };
};
